module.exports = __webpack_public_path__ + "img/20200906_162314.8bb5a7c9.jpg";